export default (state = sessionStorage.getItem('tk'), action) => {
  switch (action.type) {
    case 'SET_TOKEN':
      sessionStorage.setItem('tk', action.data)
      return action.data
    default:
      return state
  }
}
